<template>
  <TeamRequestsManager />
</template>

<script setup>
import TeamRequestsManager from '@/sections/manager/team-requests/TeamRequestsManager.vue';
</script>
